// (window.BWPhoneConversation = function ($, Behaviors) {
//     "use strict";

//     const module = {};

//     function BWPhoneConversation() {
//         const phoneConversation = document.querySelectorAll('.PhoneConversation');

//         if (!phoneConversation) {
//             return;
//         }

//         phoneConversation.forEach(phoneConvo => {
//             const observer = new IntersectionObserver( entries => {
//                 // isIntersecting is true when element and viewport are overlapping
//                 if (entries[0].isIntersecting === true) {
//                     animatePhoneConversation(phoneConvo, observer);
//                 }

//             }, {threshold: [0.3]});

//             observer.observe(phoneConvo);

//         });


//         async function animatePhoneConversation(phoneConvo, observer) {
//             const messagesContainer = phoneConvo.querySelector('.PhoneConversation__messages');
//             if (!messagesContainer) {
//                 return false;
//             }
//             const messages = [...messagesContainer.children];

//             if (!messages.length) {
//                 return false;
//             }

//             for (let i = 0; i < messages.length; i++) {
//                 await animateOpacity(messages[i]); // Wait for the first function to complete
//                 await updateText(messages[i]); // Execute second function after first is complete

//                 //scroll container if there are more messages in frame
//                 if (messages[i].offsetTop > messagesContainer.offsetHeight - 50) {
//                     messagesContainer.scrollTop = messages[i].offsetTop;
//                 }
//             }

//             observer.unobserve(phoneConvo); //make sure function is executed only once
//         }


//         function animateOpacity(message) {
//             return new Promise((resolve, reject) => {
//                setTimeout(() => {
//                    message.style.opacity = 1;
//                    resolve();
//                }, 2000);
//             });
//         }

//         function updateText(message) {
//             return new Promise((resolve, reject) => {
//                 setTimeout(() => {
//                     message.textContent = message.dataset.phoneMessageText;
//                     resolve();
//                 }, 1000);
//             });

//         }

//     }

//     module.BWPhoneConversation = BWPhoneConversation;

//     document.addEventListener('DOMContentLoaded', BWPhoneConversation);

//     return module;

// }(window.jQuery, window.Behaviors));
